import { useChannels } from '@/hooks/useChannels';

/**
 * Returns a single channel by `type` from the shop's channel list. Reuses
 * `useChannels` so we share the same SWR cache key — no second HTTP call.
 *
 * Used by the Orders page to read `config.templates.{confirmation|cancellation}`
 * for the per-channel email overrides shown in `OrderUpdateModal`.
 *
 * Returns `{ channel, isLoading, error }`. `channel` is `null` until the list
 * resolves and no entry of `type` exists.
 */
export function useChannel(type, shopId) {
	const { channels, isLoading, error } = useChannels(shopId);
	const channel = channels.find((c) => c.type === type) || null;
	return { channel, isLoading, error };
}
